import { action, computed, observable } from 'mobx';
import Address from '../../domain/entities/Address';
import { getAddressDisplayMatrix } from '../../utils/AddressUtils';
import { diContainer, serviceNames } from '../../diContainer/diContainer';
import { ADDRESS_TYPE, FIELD_TYPE } from '../../constants/Constants';
import AddressRepository from '../../repositories/AddressRepository';
import { IAddressDisplaySchema } from '../../domain/entities/Config';

interface IAddressItemData {
  addressMatrix: string[][];
}

export default class AddressItemViewController {
  @observable private addressMatrix: string[][] = [];

  @observable private displaySchema: IAddressDisplaySchema;

  @observable private addressType: ADDRESS_TYPE;

  @action
  loadDisplaySchema = async (address: Address, addressType: ADDRESS_TYPE): Promise<void> => {
    let addressRepository: AddressRepository;
    // for now only shipping and billing address type will use loadDisplaySchema method
    if (addressType === ADDRESS_TYPE.BILLING) {
      addressRepository = diContainer.get(serviceNames.billingRepository);
    } else {
      addressRepository = diContainer.get(serviceNames.shippingRepository);
    }
    this.displaySchema = await addressRepository.getAddressDisplaySchema(address?.attributes?.[FIELD_TYPE.COUNTRY_ID]);
    this.addressMatrix = getAddressDisplayMatrix(this.displaySchema, address);
    this.addressType = addressType;
  };

  @action
  updateAddressMatrix = async (address: Address): Promise<void> => {
    await this.loadDisplaySchema(address, this.addressType);
    this.addressMatrix = getAddressDisplayMatrix(this.displaySchema, address);
  };

  @computed
  get data(): IAddressItemData {
    return {
      addressMatrix: this.addressMatrix,
    };
  }
}